<template>
  <div class="Home">
    <router-view ></router-view>

    <v-dialog v-model="trocarPass" max-width="500" transition="dialog-bottom-transition">
      <v-list class=" py-0">
          <v-toolbar dark >
            <v-card-title class="headline">
              Trocar Senha
            </v-card-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="trocarPass = false;">
                  <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-toolbar>

          <v-list-item style="margin-bottom: 0 !important;">
            <div class="Container_Input d-flex flex-column align-start">
              <v-row class="flex-column align-start">
                <span>Senha atual:</span>
                <v-text-field type="password" outlined v-model="trocaSenha.sAtual"></v-text-field>
              </v-row>

              <v-row class="flex-column align-start">
                <span>Nova senha:</span>
                <v-text-field type="password" outlined v-model="trocaSenha.novaSenha"></v-text-field>
              </v-row>

              <v-row class="flex-column align-start">
                <span>Confimar nova senha:</span>
                <v-text-field type="password" outlined v-model="trocaSenha.confirmaNovaSenha"></v-text-field>
              </v-row>

              <v-row style="margin-bottom: 30px" class="d-flex justify-center">
                <v-btn class="botao" @click="trocarSenha()">Confirmar</v-btn>
              </v-row>
            </div>
          </v-list-item>
          
        </v-list>
    </v-dialog>

    <v-navigation-drawer fixed >
      <v-list dense nav >
        <v-list-item class="d-flex justify-center">
          <img width="190px" src="../assets/img/logoQR.png" />
        </v-list-item>

        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-title
              v-bind="attrs"
              v-on="on"
              v-show="logado"
              style="color: #fff"
            >
              Olá, {{ e.dsNome }}
            </v-list-item-title>
          </template>

          <v-list >
            <v-btn color="#ffdf00" style="text-transform: none;" @click="trocarPass = true">
                <v-icon
                  left
                  dark
                  small
                >
                  mdi-lock
                </v-icon>
                Trocar Senha
            </v-btn>
          </v-list>
        </v-menu>

        <v-list-item
          v-for="tab in tabs"
          :key="tab.name"
          link
          style="background-color: rgb(77, 77, 77, 0.2) !important"
        >
          <router-link :to="tab.page" style="width: 100%; color: transparent">
            <v-list-item-content>
              <v-icon color="white">{{ tab.icon }}</v-icon>
              <v-list-item-subtitle style="color: #fff; text-align: left">{{
                tab.label
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </router-link>
        </v-list-item>

        <v-list-item v-if="this.e.idVoucher == null" style="background-color: rgb(77, 77, 77, 0.2) !important">
          <router-link to="/Pagamentos" style="width: 100%; color: transparent">
            <v-list-item-content> 
              <v-icon color="white">mdi-credit-card-outline</v-icon>
              <v-list-item-subtitle style="color: #fff; text-align: left">
                Pagamentos
              </v-list-item-subtitle>
            </v-list-item-content>
          </router-link>
        </v-list-item>

        <v-list-item
          style="background-color: rgb(77, 77, 77, 0.2) !important"
        >
          <router-link to="/" style="width: 100%; color: transparent">
            <v-list-item-content @click="doLogout()"> 
              <v-icon color="white">mdi-logout-variant</v-icon>
              <v-list-item-subtitle style="color: #fff; text-align: left">
                Sair
              </v-list-item-subtitle>
            </v-list-item-content>
          </router-link>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<style scoped>
ons-tabbar {
  max-width: 70vw;
  margin: 30px auto auto auto;
}
#HomePage {
  background-color: #e6e6e6 !important;
}
.headline {
  font-size: 1.2rem !important;
  text-transform: none;
}
.Container_Input {
  padding-top: 20px !important; 
  width: 100% !important;
}
.Container_Input .row {
  margin-left: 15px;
  width: 95%;
}
.v-text-field {
  min-width: 440px !important;
}
.theme--light.v-navigation-drawer {
  background-color: #212226 !important;
  background-image: url("../assets/img/BgMenu.png") !important;
  background-size: cover !important;
  background-position: right;
}

.v-menu__content .v-sheet {
  background: rgb(107 106 106 / 95%) !important;
}

.v-list-item__title {
    font-size: 1rem !important;
    font-weight: 500;
    line-height: 1rem;
    letter-spacing: 1px !important;
    text-transform: none;
    margin: 25px 0 !important;
}

.v-list-item{
  margin-bottom: 10px !important;
  text-transform: none;
}

.v-list-item__content{
  display: grid !important;
  grid-template-columns: 18% 46% !important;
  justify-content: center !important;
  border-radius: 5px;
}

</style>

<script>

import { isNullOrUndefined } from "util";

export default {
  name: "Home",
  key: "Home",
  props: ["pageStack"],
  data() {
    return {
      modalVisible: false,
      activeIndex: 0,
      menu: false,
      trocarPass: false,
      trocaSenha: {},
      tabs: [
        {
          label: "Principal",
          page: '/Home',
          icon: "mdi-home",
          name: "principal",
        },
        {
          label: "Minha Loja",
          page: '/MinhaLoja',
          icon: "mdi-store",
          name: "minhaloja",
        },
        {
          label: "Cardápio",
          page: '/Cardapio',
          icon: "mdi-silverware",
          name: "cardapio",
        },
        {
          label: "Qr Codes",
          page: '/QrCodes',
          icon: "mdi-qrcode",
          name: "qrcode",
        },
        {
          label: "Funções",
          page: '/Funcionalidades',
          icon: "mdi-plus-circle-outline",
          name: "funcionalidades",
        },
        // { label: "Quiz", 
        //   page: '/Quiz', 
        //   icon: "mdi-timer-sand-full", 
        //   name: "quiz" },
        {
          label: "Contato",
          page: '/Contato',
          icon: "mdi-email",
          name: "contato",
        },
      ],
      e: {},
      logado: false,
    };
  },
  created() {
    var e = localStorage.getItem("e");
    if (!isNullOrUndefined(e)) {
      this.e = JSON.parse(e);
      this.logado = true;
    }
  },
  methods: {
    doLogout(){
      localStorage.removeItem("e");
      localStorage.setItem("makeLogin", false);
      this.e = {};
      this.logado = false;
    },
    trocarSenha() {
      if (this.trocaSenha.novaSenha != this.trocaSenha.confirmaNovaSenha) {
        this.$ons.notification.toast(
          "A confirmação não coincide com a nova senha! ",
          { timeout: 1000, animation: "ascend" }
        );
        return;
      }
      this.trocaSenha.idEstabelecimento = this.e.idEstabelecimento;
      fetch(this.$menu_uri + "/trocar-senha", {
        method: "OPTIONS",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.trocaSenha),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === 1) {
            this.trocarPass = false,
            this.trocaSenha = {
              sAtual: "",
              novaSenha: "",
              confirmaNovaSenha: "",
            };
            (this.trocarPass = false),
              this.$ons.notification.toast("Senha alterada com sucesso! ", {
                timeout: 1000,
                animation: "ascend",
              });
          } else {
            this.$ons.notification.toast(
              "Ocorreu um erro, confira sua senha atual! ",
              { timeout: 1000, animation: "ascend" }
            );
          }
        })
        .then((error) => {
          if (error) {
            window.log(error);
            this.$ons.notification.toast("Erro de rede, tente novamente! ", {
              timeout: 1000,
              animation: "ascend",
            });
          }
        });
    },
  },
};
</script>